/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Search\SearchByTerm.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Friday January 19th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday January 19th 2024 11:43:36 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";

type ApplySearchProps = {
    searchFunc: Function;
    setResult: Function,
    setSearchTerm?: Function,
    searchTerm?: string,
    secondArg?: string,
    // queryParams?: QueryParams,
    title: string,
};

function SearchByTerm(props: ApplySearchProps) {
    const [searchValue, setSearchValue] = useState<string | null>(null);
    const [searchOptions, setSearchOptions] = useState<{result: any, label: string}[]>([]);
    const [searchInputValue, setSearchInputValue] = useState<string>(props.searchTerm ? decodeURIComponent(props.searchTerm) : "");
    const firstLoad = useRef(true);

    const selectedInput = useMemo(() => {
        let optionFound = searchOptions.filter((v) => v.label === searchValue);
        if (optionFound.length > 0)
            return optionFound[0].label;
        return searchValue;
    }, [searchInputValue]);

    const selectableOptions = useMemo(() => {
        return searchOptions.map(v => v.label);
    }, [searchOptions]);

    useEffect(() => {
        if (firstLoad.current && props.setSearchTerm)
            props.setSearchTerm(searchInputValue);

        const beforeSearch = setTimeout(async () => {
            await handleSearchOptions(searchInputValue);
        }, 500);
            return () => clearTimeout(beforeSearch);
    }, [searchInputValue]);

    const handleSearchOptions = async (input: string) => {
        let searchIndex = searchOptions.findIndex((val) => val.label === input);
        if (input.length >= 3 && searchIndex === -1) {
            props.searchFunc(input, props.secondArg).then((searchOptions: {label: string, result: any}[]) => {
                if (searchOptions) {
                    setSearchOptions(searchOptions);
                    props.setResult(searchOptions);
                }
            });
                // setSearchOptions(searchOptions.map((v: any ) => {return {label: v.Name, result: v}}));
        } else if (searchIndex !== -1) {
            props.setResult([searchOptions[searchIndex]]);
            setSearchOptions([searchOptions[searchIndex]]);
        } else {
            props.setResult([]);
            setSearchOptions([]);
        }
    };

    return (
        <Autocomplete
            freeSolo
            value={selectedInput}
            onChange={async (event: any, newValue: string | null) => {
                setSearchValue(newValue);
                if (newValue)
                    props.setResult([searchOptions.filter((v) => v.label === newValue)[0]]);
                else
                    props.setResult([]);
            }}
            inputValue={searchInputValue}
            // onClickCapture={async () => {
            //     await handleSearchOptions(searchInputValue);
            // }}
            filterOptions={x => x}
            onInputChange={async (event, input) => {
                // await handleSearchOptions(input);
                setSearchInputValue(input);
            }}
            id="combo-box-company"
            options={selectableOptions}
            sx={{ width: 300, backgroundColor:"white" }}
            renderInput={(params) => <TextField autoFocus {...params} label={props.title} />}
        />
    )
}

export default SearchByTerm;
